import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveSystemApplication } from "./index";

// Api's
import { systemApplicationApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getSystemApplicationSaga() {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(systemApplicationApi.getDomain);
		if (response.data.result) {
			yield put(saveSystemApplication(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveSystemApplication(null, true, resultError.messagesDataError));
		}
	}
}
